import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export const cn = (...inputs: ClassValue[]): string => {
  return twMerge(clsx(inputs))
}

export const withoutTrailingSlash = (value: string | null | undefined): string | undefined => {
  if (!value) return undefined
  return value.endsWith('/') ? value.slice(0, -1) : value
}
